import { frontendURL } from '../../../../helper/URLHelper';

const agentsIa = accountId => ({
  parentNav: 'agents-ia',
  routes: ['agents-ia'],
  menuItems: [
    {
      icon: 'list',
      label: 'AGENT_ATENTY.LIST',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/agents-ia`),
      toStateName: 'agents-ia',
    },
  ],
});

export default agentsIa;